/**
 * External Dependencies
 */
import { get, flatten } from 'lodash';

/**
 * Internal dependencies
 */
import getCubeMeta from './get-cube-meta';

export default (state) => {
    const cubes = get(getCubeMeta(state), ['cubes'], []);
    return [...flatten(cubes.map(({ dimensions }) => dimensions)), ...flatten(cubes.map(({ measures }) => measures))];
};
